export class RequestFormModel {
  tblRequestId: number = 0;
  mainParentRequestId: number = 0;
  parentRequestId: number = 0;
  clientId: number = 0;
  FormId: string = "";
  requestNo: string = "";
  requestedDate: Date = new Date();
  requestedDateStr: string = "";
  requestedByEmployeeId: number = 0;
  requestedBy: string = "";
  requestedByEmail: string = "";
  emailCC: string = "";
  tblUrgencyRateId: number = 0;
  tblDepartmentId: number = 0;
  tblDepartmentId2: number = 0;
  userContactDetailsId: number = 0;
  tblRequestTypeId: number = 0;
  tblRequestType: string = "";
  tblRequestStatusId: number = 0;
  subject: string = "";
  comments: string = "";
  instructions: string = "";
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
  tblServiceMasterId: number = null;
}


export class RequestFormConfigurationModel {
  formId: string = "IMVO-REQU";
  pkTableId: string = "";
  formTitle: string = "Request Form";
  addFormName: string = "New Request";
  editFormName: string = "Edit Request";
  listReportFormName: string = "";

  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  saveCustomerFromParent: boolean = false;
  displayListCardView: boolean = false;




  requiredFields: RequiredFields = new RequiredFields();
  allowedFields: AllowedFields = new AllowedFields();

  fieldsTitle: FieldsTitle = new FieldsTitle();
  fieldsFormat: FieldsFormat = new FieldsFormat();
}

export class AllowedFields {
  requestNo: boolean = true;
  requestedDateStr: boolean = true;
  requestedBy: boolean = true;
  requestedByEmail: boolean = true;
  tblRequestType: boolean = true;
  attachFile: boolean = false;
  tblUrgencyRateId: boolean = true;
  tblRequestStatusId: boolean = true;
  subject: boolean = true;
  comments: boolean = true;
  tblDepartmentId: boolean = true;
}


export class RequiredFields {
  requestNo: boolean = true;
  requestedDateStr: boolean = true;
  requestedBy: boolean = true;
  requestedByEmail: boolean = true;
  tblRequestType: boolean = true;
  tblUrgencyRateId: boolean = true;
  tblRequestStatusId: boolean = true;
  subject: boolean = true;
  comments: boolean = true;
  tblDepartmentId: boolean = true;
}


export class ValidationModel {

  isTblRequestNoValid: boolean = true;
  tblRequestNoValidationMessage = "Request Number Is Required";

  isRequestedDateStrValid: boolean = true;
  requestedDateStrValidationMassage = "Requested Date Is Required";

  isRequestedByValid: boolean = true;
  requestedByValidationMessage = "Requested By Is Required";

  isTblRequestTypeValid: boolean = true;
  tblRequestTypeIdValidationMessage = "Request Type Is Required";

  isTblUrgencyRateIdValid: boolean = true;
  tblUrgencyRateIdValidationMessage = "Urgency Rate Is Required";

  isTblRequestStatusIdValid: boolean = true;
  tblRequestStatusIdValidationMessage = "Request Status Is Required";

  isSubjectValid: boolean = true;
  subjectValidationMessage = "Subject Is Required";

  isCommentsValid: boolean = true;
  commentsValidationMessage = "Comments Is Required";

  isEmailValid: boolean = true;
  emailValidationMessage = "Email Is Required";
}
export class FieldsTitle {
  firstName: string = "First Name";
  mobile: string = "Mobile";
  telephone: string = "Telephone";
}
export class FieldsFormat {
  telephone: string = "";
  mobile: string = "";
}
